import React from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '@uncinc/uncinc-react-kitchen-sink';

import Card from '../../../../components/Card';

import './style.scss';

export interface NodeVacancyCardProps {
  title: string;
  subtitle?: string;
  link: string;
  departments?: string[];
  locations?: string[];
}

const NodeVacancyCard: React.FC<NodeVacancyCardProps> = (props) => {
  const {
    title,
    subtitle,
    link,
    departments,
    locations,
  } = props;

  const { t } = useTranslation();

  return (
    <Card className="NodeVacancyCard" {...link && { withLink: true }}>
      <Card.Content>
        <div className="Card__content__text">
          <Card.Link href={link}>
            <Card.Title title={title} /><Icon name="arrow_outward" flair="outlined" />
          </Card.Link>

          {subtitle && (
            <Card.Subtitle
              subtitle={(
                <p className="u-truncate--2 body--small">
                  {subtitle}
                </p>
              )}
            />
          )}

          {(locations && locations.length > 0) && (
            <div className="Card__location body--tiny">
              <Icon name="location_on" flair="outlined" />{locations[0]}, {t('countries:NL')}
            </div>
          )}

          {(departments && departments.length > 0) && (
            <div className="Card__content__metadata">
              <Card.Tags
                tags={departments.map((department) => ({ name: department, type: 'departments' }))}
              />
            </div>
          )}
        </div>
      </Card.Content>
    </Card>
  );
};

export default NodeVacancyCard;
